var map = {
	"./child.png": 610,
	"./dental-chair.png": 1071,
	"./dental-x-ray.png": 6065,
	"./endodontics.png": 9602,
	"./frenulotomy.png": 8703,
	"./injekcijska.png": 9794,
	"./invisalign.png": 474,
	"./laser.png": 6631,
	"./myobrace.png": 9362,
	"./periodontitis.png": 170,
	"./prosthetics.png": 2645,
	"./tooth-decay.png": 3953,
	"./whitening.png": 8754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2929;